import { NgModule } from '@angular/core'
import OpenStreetMapWithMarkerComponent from '@layouts/default/components/open-street-map-with-marker/open-street-map-with-marker.component'
import { CommonModule } from '@angular/common'
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

@NgModule({
    declarations: [OpenStreetMapWithMarkerComponent],
    exports: [OpenStreetMapWithMarkerComponent],
    imports: [CommonModule, LeafletModule]
})
export class OpenStreetMapWithMarkerModule {
}
